export default __webpack_public_path__ + "static/media/menu_top_recordings_okara.aee26cce.svg";